'use strict';

angular.module('magtac')
  .controller('StatusGeneralCtrl', [
    '$scope', 'statusGeneralViewModel', '$stateParams',
    function ($scope, viewModel, $stateParams) {
      $scope.model = new viewModel(parseInt($stateParams.key));
    }
  ]);